"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderAnalyticsDay = exports.RiderAnalyticsDayStruct = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
/**
 * @deprecated use `RiderStats` instead!
 */
exports.RiderAnalyticsDayStruct = (0, superstruct_1.type)({
    /**
     * e.g. 2022-02-28
     */
    averageDeliverySeconds: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    averageReturnToStoreSeconds: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    date: (0, superstruct_1.string)(),
    numberOfEvaluatedTasks: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    numberOfSucceededTasks: (0, superstruct_1.number)(),
    onDutyMinutes: (0, superstruct_1.optional)((0, superstruct_1.number)()),
});
function isRiderAnalyticsDay(obj) {
    return (0, isStruct_1.isStruct)(obj, exports.RiderAnalyticsDayStruct, "RiderAnalyticsDay");
}
exports.isRiderAnalyticsDay = isRiderAnalyticsDay;
